import { FC, useEffect } from 'react';
import { AlertCircle } from 'lucide-react';


interface ErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message: string;
}

const ErrorModal: FC<ErrorModalProps> = ({
  isOpen,
  onClose,
  title = 'Ошибка',
  message,
}) => {
  // Закрытие по Escape
  useEffect(() => {
    if (!isOpen) return;

    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-50 transition-opacity animate-fadeIn"
      onClick={(e) => {
        // Закрытие по клику на backdrop
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="bg-white dark:bg-zinc-900 rounded-xl shadow-lg w-full max-w-md p-6 border border-gray-100 dark:border-zinc-800 transform transition-all scale-100 hover:scale-[1.02] duration-150 ease-out">
        <div className="flex items-center mb-4">
          <AlertCircle className="w-12 h-12 text-red-500 mr-3 flex-shrink-0" />
          <h2 className="text-xl font-bold text-gray-900 dark:text-zinc-100">{title}</h2>
        </div>

        <p className="text-gray-700 dark:text-zinc-200 mb-4 leading-relaxed whitespace-pre-line max-h-96 overflow-y-auto">
          {message}
        </p>
        
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-8 rounded-lg shadow-sm transition-transform transform hover:scale-105"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
